<template>
  <Navigation withExit @back="emit('back')" @exit="emit('exit')" />
  <Title>
    {{ i18n(translations.title) }}
    <template #subtitle>
      {{ i18n(translations.outOfWarranty) }}
    </template>
  </Title>

  <p class="text-static-default-low body-1 mb-24">
    {{ i18n(translations.intro) }}
  </p>

  <UploadEvidence
    :isLoading
    :mostUrgentTask
    :uploadLabel="i18n(translations.uploadFieldLabel)"
    @submit="(values) => emit('submit', values)"
  >
    <RevInfoBlock
      class="w-1/2"
      :icon="IconLightbulb"
      :title="i18n(translations.hintTitle)"
      variant="default"
    >
      <ul class="body-2 list-disc pl-4 pt-3">
        <li>{{ i18n(translations.hint1) }}</li>
        <li>{{ i18n(translations.hint2) }}</li>
      </ul>
    </RevInfoBlock>
  </UploadEvidence>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconLightbulb } from '@ds/icons/IconLightbulb'

import type { OrderlineOpenTask } from '~/api/seller-after-sales/types'

import Navigation from '../../../Navigation/Navigation.vue'
import Title from '../../../Title/Title.vue'
import UploadEvidence from '../components/UploadEvidence/UploadEvidence.vue'

import translations from './OutOfWarrantyItem.translations'

defineProps<{
  isLoading: boolean
  mostUrgentTask?: OrderlineOpenTask
}>()

const emit = defineEmits(['back', 'exit', 'submit'])

const i18n = useI18n()
</script>
